import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosClient from "../AxiosClient";


// Active Bundle Apis
export const getActiveBundleListAsync = createAsyncThunk(
  'market/getActiveBundleListAsync',
  async function (
    params: { paramData: { platform_id:number;
        page: number; limit?: number; sort_by?: string; sort_order?: string; search?: string; isActive?: boolean; include?: string;
      } }, toolkit
  ) {
    return await AxiosClient('GET', `/api/product-variant-bundle-relation`, [], toolkit, params.paramData, toolkit.signal)
  }
)

export const createBundleItemAsync = createAsyncThunk(
  'market/createBundleItemAsync',
  async function (payload: any, toolkit) {
    const url = `/api/product-variant-bundle-relation`
    return await AxiosClient('POST', url, payload, toolkit, [])
  }
)
export const updateBundleItemAsync = createAsyncThunk(
  'market/updateBundleItemAsync',
  async function (payload: {payloadupdate: any }, toolkit) {
    const url = `/api/product-variant-bundle-relation`
    return await AxiosClient('PUT', url, payload.payloadupdate, toolkit, [])
  }
)
export const updateActiveInactiveAsync = createAsyncThunk(
  'market/updateActiveInactiveAsync',
  async function (payload: { id: number;}, toolkit) {
    const url = `/api/product-variant-bundle-relation?bundle_relation_id=${payload.id}`
    return await AxiosClient('PUT', url, [], toolkit, [])
  }
)

export const deleteBundleItemAsync = createAsyncThunk(
  'market/deleteBundleItemAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `/api/product-variant-bundle-relation?bundle_relation_id=${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

export const getEditBundleDataAsync = createAsyncThunk(
  'market/getEditBundleDataAsync',
  async function (payload: { id: number }, toolkit) {
    const url = `/api/product-variant-bundle-relation?bundle_relation_id=${payload?.id}`
    return await AxiosClient('GET', url, [], toolkit, [])
  })